const rankings = [
  { rank: 1, title: '顶流男星深夜密会神秘女子，狗仔蹲守三个月终拍实锤', hot: '983万', trend: 'up' },
  { rank: 2, title: '选秀节目选手私下群聊记录曝光，内容劲爆引节目组紧急回应', hot: '876万', trend: 'up' },
  { rank: 3, title: '头部网红直播间口误事件持续发酵，品牌解约潮蔓延至海外', hot: '754万', trend: 'up' },
  { rank: 4, title: '知名综艺录制现场嘉宾翻脸离场，节目组紧急删减相关片段', hot: '689万', trend: 'up' },
  { rank: 5, title: '影视公司内部邮件泄露，年度重点项目因主演出轨被紧急叫停', hot: '567万', trend: 'new' },
  { rank: 6, title: '二次元顶流UP主早年争议言论被扒出，超话排名一夜暴跌', hot: '498万', trend: 'up' },
  { rank: 7, title: '直播平台刷单事件官方通报：涉事主播永久封禁并追责', hot: '432万', trend: 'new' },
];

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-end justify-between">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              热搜榜单<i className="ri-fire-line text-primary-500 ml-2"></i>
            </h2>
            <p className="mt-2 text-sm text-foreground-500">实时热度排行 · 每分钟更新</p>
          </div>
          <div className="hidden sm:flex items-center gap-2 text-xs">
            <span className="px-2 py-1 rounded-md bg-primary-100 text-primary-700 font-semibold cursor-pointer">实时</span>
            <span className="px-2 py-1 rounded-md text-foreground-500 cursor-pointer hover:bg-background-100 transition-colors">今日</span>
            <span className="px-2 py-1 rounded-md text-foreground-500 cursor-pointer hover:bg-background-100 transition-colors">本周</span>
          </div>
        </div>

        <div className="mt-6">
          <div className="bg-background-100 rounded-2xl border border-background-200/70 overflow-hidden">
            {rankings.map((item) => (
              <article
                key={item.rank}
                className="flex items-center gap-3 md:gap-4 px-4 md:px-6 py-4 hover:bg-background-50 transition-colors border-b border-background-200/50 last:border-b-0 cursor-pointer"
              >
                <div className={`w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-lg text-sm font-bold ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-200 text-foreground-600'
                }`}>
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 truncate">{item.title}</h3>
                </div>
                <div className="flex items-center gap-1.5 flex-shrink-0">
                  {item.trend === 'new' && (
                    <span className="text-xs px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 font-semibold whitespace-nowrap">NEW</span>
                  )}
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.hot} 热度</span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}